import axios from '../utils/axios';

export default function deleteCETestimonial(adminId, id, data) {
    return (
        axios.post('/admin/' + adminId +'/client-engagement/testimonials/' + id +  '/delete',  data )
    )
}
